var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import useAlert from './useAlert';
import { useQuery } from '@tanstack/vue-query';
import useSentry from './useSentry';
import { computed } from 'vue';
import { getResponseErrorMessage } from '@mumble/helpers';
export default function useFetch(key, api, options) {
    var log = useSentry().log;
    var onError = options === null || options === void 0 ? void 0 : options.onError;
    var opts = __assign(__assign({}, options), { onError: function (e) {
            if (!(options === null || options === void 0 ? void 0 : options.disableSentry))
                log(e, options === null || options === void 0 ? void 0 : options.logOptions);
            if (onError)
                onError(e);
        } });
    var fetch = useQuery(key, api, opts);
    var alert = useAlert({ fetch: fetch });
    var errorMessage = computed(function () { return (fetch.error.value ? getResponseErrorMessage(fetch.error.value) : undefined); });
    return __assign(__assign({}, fetch), { isLoading: fetch.isLoading, alert: alert, errorMessage: errorMessage });
}
